import { commonAssessmentKitConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

// login
export const invite_candidate_to_assessment_kit_action =
  (data) => async (dispatch) => {
    dispatch({
      type: commonAssessmentKitConstants.INVITE_CANDIDATE_TO_ASSESSMENT_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.common.inviteCandidateToAseessment,
        data
      );
      if (response.status) {
        dispatch({
          type: commonAssessmentKitConstants.INVITE_CANDIDATE_TO_ASSESSMENT_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("Candidate successfully invited to assessment.");
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: commonAssessmentKitConstants.INVITE_CANDIDATE_TO_ASSESSMENT_ACTION_FAILURE,
        payload: e?.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

export const invited_assessment_kits_candidate_action =
  (data) => async (dispatch) => {
    dispatch({
      type: commonAssessmentKitConstants.INVITED_ASSESSMENT_KITS_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.common.invitedAssessmentsCandidate
      );
      if (response.status) {
        dispatch({
          type: commonAssessmentKitConstants.INVITED_ASSESSMENT_KITS_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: commonAssessmentKitConstants.INVITED_ASSESSMENT_KITS_CANDIDATE_ACTION_FAILURE,
        payload: e?.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };
